import { useState } from "react"

import { useSelectContext } from "@molecules/Select/Select.context"
import SelectListFooter from "@molecules/Select/SelectListFooter/SelectListFooter"

import { SelectCustomValueProps } from "./SelectCustomValue.types"

export default function SelectCustomValue(props: SelectCustomValueProps) {
    const { listInputProps } = props
    const { customValue } = useSelectContext()
    const [isEditing, setIsEditing] = useState(!!customValue)

    if (customValue || isEditing) {
        return <SelectListFooter variant="select-input" selectInput={{ ...listInputProps }} />
    } else {
        return (
            <SelectListFooter
                variant="menu-item"
                menuItem={{ label: "Set custom value", onClick: () => setIsEditing(true) }}
            />
        )
    }
}
